"use strict";

require("core-js/modules/esnext.weak-map.delete-all.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toolbarCss = exports.default = exports.WHITELABEL_SELECTOR_CLASS = exports.SIZE_SMALL = exports.SIZE_MEDIUM = exports.SIZE_LARGE = exports.SIZE_HUGE = exports.SIZE_DEFAULT = exports.PROP_TYPES = exports.PROP_SIZES = exports.CHEVRON_POSITIONS = exports.CHEVRON_DIRECTIONS = exports.ButtonStyled = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _IconChevronLeft = _interopRequireDefault(require("../Icon/IconChevronLeft"));
var _IconChevronRight = _interopRequireDefault(require("../Icon/IconChevronRight"));
var _theme = _interopRequireDefault(require("../../theme"));
var _appTheme = _interopRequireDefault(require("../../appTheme"));
var _LoadingSpinner = _interopRequireDefault(require("../LoadingSpinner"));
var _helpers = require("../../helpers");
var _variables = require("../../css/variables");
var _selectors = require("../../css/selectors");
const _excluded = ["color", "colorHover", "svgClassName", "noSvgStyles", "getDefaultColor", "getDefaultHoverColor", "type"],
  _excluded2 = ["size", "type", "toolbar", "colorDisabled", "color", "colorHover", "background", "backgroundHover", "svgWidth", "svgHeight", "noSvgStyles", "positioning", "withShadow", "useAppTheme"],
  _excluded3 = ["to", "target", "href", "type", "size", "children", "isSubmit", "className", "isLoading", "withShadow", "chevron", "linkComponent", "alwaysUseLinkComponent", "buttonComponent", "background", "backgroundHover", "color", "colorHover", "noSvgStyles", "useAppTheme", "getDefaultBackground", "getDefaultColor", "getDefaultFocusBackground", "getDefaultFocusColor", "getDefaultHoverBackground", "getDefaultHoverColor", "getDefaultLinkColor", "getDefaultLinkHoverColor"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const EXTERNAL_NAME = 'button';
const WHITELABEL_SELECTOR_CLASS = exports.WHITELABEL_SELECTOR_CLASS = `anvil-${EXTERNAL_NAME}`;
const SIZE_SMALL = exports.SIZE_SMALL = 'small';
const SIZE_DEFAULT = exports.SIZE_DEFAULT = 'default';
const SIZE_MEDIUM = exports.SIZE_MEDIUM = 'medium';
const SIZE_LARGE = exports.SIZE_LARGE = 'large';
const SIZE_HUGE = exports.SIZE_HUGE = 'huge';
const PROP_SIZES = exports.PROP_SIZES = [SIZE_SMALL, SIZE_DEFAULT, SIZE_MEDIUM, SIZE_LARGE, SIZE_HUGE];
const PROP_TYPES = exports.PROP_TYPES = ['link', 'primary', 'default', 'cta', 'cta-alt', 'cta-light', 'danger', 'faded', 'toolbar', 'black', 'dark',
// ui/marketing site only; no app
'outline-default', 'outline-faded', 'outline-light', 'outline-green', 'outline-red', 'yellow', 'solid-black', 'inactive', 'white', 'toggle-active', 'toggle-inactive'];
const CHEVRON_DIRECTIONS = exports.CHEVRON_DIRECTIONS = ['left', 'right'];
const CHEVRON_POSITIONS = exports.CHEVRON_POSITIONS = ['inner', 'outer'];
const transition = '.2s cubic-bezier(.645,.045,.355,1)';
const CHEVRON_CLASS_NAME = 'button-chevron';
const getDeclaration = ({
  property,
  variableName,
  value,
  selectors,
  isImportant,
  declarations,
  blockName,
  applyToElementDirectly
}) => (0, _variables.createVariablizedCss)({
  variablePrefix: EXTERNAL_NAME,
  variableName,
  property,
  value,
  isImportant,
  selectors,
  declarations,
  blockName,
  applyToElementDirectly
});
const toolbarCss = exports.toolbarCss = (0, _styledComponents.css)`
  padding: 0 8px;
  display: flex;
  height: 28px;
  line-height: 28px;
  align-items: center;
  font-size: 14px !important;
  > svg {
    display: block;
    margin-right: 8px;
    &:last-child {
      margin-right: 0;
    }
  }
`;
const svgColorStyles = _ref => {
  let {
      color,
      colorHover,
      svgClassName,
      noSvgStyles,
      getDefaultColor,
      getDefaultHoverColor
    } = _ref,
    others = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  const fillValue = getDeclaration({
    variableName: 'icon-color',
    value: getDeclaration({
      variableName: 'color',
      value: getDefaultColor ? getDefaultColor(color) : color
    })
  });
  const hoverFillValue = getDeclaration({
    variableName: 'icon-hover-color',
    value: getDeclaration({
      variableName: 'hover-color',
      value: getDefaultHoverColor ? getDefaultHoverColor(colorHover || color) : colorHover || color
    })
  });
  return `
  ${!noSvgStyles && color && `
  ${svgClassName ? `svg.${svgClassName}` : 'svg'} {
      path,
      polygon,
      circle,
      rect {
        fill: ${fillValue};
      }
    }
  `}

  &:active,
  &:hover {
    ${!noSvgStyles && (colorHover || color) && `${svgClassName ? `svg.${svgClassName}` : 'svg'} {
          path,
          polygon,
          circle,
          rect {
            fill: ${hoverFillValue};
          }
      }`}
  }
`;
};

// TODO: see if css tag from styled components can be used to make this more
// readable within text editors - provides syntax highlighting
const svgStyle = ({
  color,
  colorHover,
  width = '16px',
  height = '16px',
  verticalAlign = 'text-bottom',
  noSvgStyles,
  svgClassName,
  getDefaultColor,
  getDefaultHoverColor
}) => !noSvgStyles && `
  ${svgClassName ? `svg.${svgClassName}` : 'svg'} {
    vertical-align: ${verticalAlign};
    display: inline-block;
    margin-right: 6px;
    width: ${width};
    height: ${height};

    &:last-child {
      margin-right: 0;
    }
  }

  ${svgColorStyles({
  color,
  colorHover,
  svgClassName,
  noSvgStyles,
  getDefaultColor,
  getDefaultHoverColor
})}
  `;
const commonButtonStyles = ({
  color,
  colorHover,
  colorDisabled,
  border,
  borderHover,
  background,
  backgroundHover,
  opacityDisabled,
  useAppTheme,
  getDefaultBackground,
  getDefaultColor,
  getDefaultFocusColor,
  getDefaultFocusBackground,
  getDefaultHoverColor,
  getDefaultHoverBackground
}) => {
  return `
  ${getDeclaration({
    property: 'color',
    value: getDefaultColor ? getDefaultColor(color) : color
  })}
  ${getDeclaration({
    property: 'background',
    value: getDefaultBackground ? getDefaultBackground(background || 'transparent') : background || 'transparent'
  })}
  ${getDeclaration({
    property: 'font-weight',
    value: (useAppTheme ? _appTheme.default : _theme.default).fontWeights.bold
  })}
  ${getDeclaration({
    property: 'transition',
    value: `color ${transition}, background ${transition}, border-color ${transition}, width ${transition}, box-shadow ${transition}`
  })}

  ${getDeclaration({
    blockName: _selectors.BLOCK_NAME_FOCUS,
    selectors: [':focus'],
    declarations: [{
      property: 'color',
      value: getDefaultFocusColor ? getDefaultFocusColor(colorHover || color) : colorHover || color
    }],
    applyToElementDirectly: true
  })}

  ${getDeclaration({
    blockName: _selectors.BLOCK_NAME_HOVER,
    declarations: [{
      property: 'color',
      value: getDefaultHoverColor ? getDefaultHoverColor(colorHover || color) : colorHover || color
    }, {
      property: 'background',
      value: getDefaultHoverBackground ? getDefaultHoverBackground(backgroundHover || 'white') : backgroundHover || 'white'
    }, {
      property: 'border-color',
      value: borderHover || border || colorHover || color
    }, {
      property: 'box-shadow',
      value: _appTheme.default.shadows[60]
    }],
    applyToElementDirectly: true
  })}
  

  ${getDeclaration({
    blockName: _selectors.BLOCK_NAME_DISABLED,
    declarations: [{
      property: 'cursor',
      value: 'not-allowed'
    }, {
      property: 'color',
      value: colorDisabled || color
    }, {
      property: 'opacity',
      value: opacityDisabled || '.5'
    }, {
      property: 'border-color',
      value: border || colorDisabled
    }],
    applyToElementDirectly: true
  })}  


  ${(0, _selectors.getSelectorGroup)({
    blockName: _selectors.BLOCK_NAME_DISABLED,
    opts: {
      applyToElementDirectly: true
    }
  })} {
    path,
    polygon,
    circle,
    rect {
      fill: ${getDeclaration({
    variableName: 'disabled-icon-color',
    value: getDeclaration({
      variableName: 'disabled-color',
      value: getDeclaration({
        variableName: 'color',
        value: color
      })
    })
  })};
    }

    ${(0, _selectors.getSelectorGroup)({
    blockName: _selectors.BLOCK_NAME_HOVER,
    opts: {
      applyToElementDirectly: true
    }
  })} {
      path,
      polygon,
      circle,
      rect {
        fill: ${getDeclaration({
    variableName: 'disabled-icon-hover-color',
    value: getDeclaration({
      variableName: 'disabled-icon-color',
      value: getDeclaration({
        variableName: 'disabled-hover-color',
        value: getDeclaration({
          variableName: 'hover-color',
          value: colorHover || color
        })
      })
    })
  })};
      }
    }
  }
`;
};
const buttonVariantSolid = ({
  color,
  colorHover,
  colorDisabled,
  border,
  borderHover,
  background,
  backgroundHover,
  opacityDisabled,
  size,
  svgWidth,
  svgHeight,
  noSvgStyles,
  chevronColor,
  chevronColorHover,
  chevronClassName,
  useAppTheme,
  getDefaultBackground,
  getDefaultColor,
  getDefaultFocusBackground,
  getDefaultFocusColor,
  getDefaultHoverBackground,
  getDefaultHoverColor
}) => `
  ${size === 'huge' ? 'line-height: 64px;' : ''}
  border-width: 0;

  ${commonButtonStyles({
  color,
  colorHover,
  colorDisabled,
  border,
  borderHover,
  background,
  backgroundHover,
  opacityDisabled,
  useAppTheme,
  getDefaultBackground,
  getDefaultColor,
  getDefaultFocusBackground,
  getDefaultFocusColor,
  getDefaultHoverBackground,
  getDefaultHoverColor
})}

  ${svgStyle({
  color: chevronColor || color,
  colorHover: chevronColorHover || colorHover,
  svgClassName: chevronClassName,
  width: svgWidth,
  height: svgHeight,
  noSvgStyles,
  getDefaultColor,
  getDefaultHoverColor
})}

  ${getDeclaration({
  blockName: _selectors.BLOCK_NAME_FOCUS,
  selectors: [':focus'],
  declarations: [{
    property: 'background',
    value: getDefaultFocusBackground ? getDefaultFocusBackground(background) : background
  }],
  applyToElementDirectly: true
})}

  ${getDeclaration({
  blockName: _selectors.BLOCK_NAME_DISABLED,
  declarations: [{
    property: 'background',
    value: background
  }],
  applyToElementDirectly: true
})}  
`;
const buttonVariantOutline = ({
  color,
  colorHover,
  colorDisabled,
  border,
  borderHover,
  opacityDisabled,
  background,
  backgroundHover,
  size,
  svgWidth,
  svgHeight,
  noSvgStyles,
  chevronColor,
  chevronColorHover,
  chevronClassName,
  useAppTheme,
  getDefaultBackground,
  getDefaultColor,
  getDefaultFocusBackground,
  getDefaultFocusColor,
  getDefaultHoverBackground,
  getDefaultHoverColor
}) => `
  ${size === 'huge' ? 'line-height: 60px;' : ''}
  ${getDeclaration({
  property: 'border',
  value: `2px solid ${border}`,
  isImportant: true
})}

  ${commonButtonStyles({
  color,
  colorHover,
  colorDisabled,
  border,
  borderHover,
  background,
  backgroundHover,
  opacityDisabled,
  useAppTheme,
  getDefaultBackground,
  getDefaultColor,
  getDefaultFocusBackground,
  getDefaultFocusColor,
  getDefaultHoverBackground,
  getDefaultHoverColor
})}

 ${svgStyle({
  color: chevronColor || color,
  colorHover: chevronColorHover || colorHover,
  svgClassName: chevronClassName,
  width: svgWidth,
  height: svgHeight,
  noSvgStyles,
  getDefaultColor,
  getDefaultHoverColor
})}

  ${getDeclaration({
  blockName: _selectors.BLOCK_NAME_FOCUS,
  selectors: [':focus'],
  declarations: [{
    property: 'background',
    value: backgroundHover || 'white'
  }, {
    property: 'border-color',
    value: border,
    isImportant: true
  }],
  applyToElementDirectly: true
})}
`;
const buttonVariantLink = ({
  color,
  colorHover,
  colorDisabled,
  svgWidth,
  svgHeight,
  noSvgStyles,
  getDefaultLinkColor,
  getDefaultLinkHoverColor
}) => `
  ${getDeclaration({
  property: 'font-weight',
  value: '400'
})}

  // NOTE: i think ant-btn is needed to make sure the button is styled correctly,
  // mostly because of specificity
  &.ant-btn {
    ${getDeclaration({
  property: 'color',
  value: getDefaultLinkColor ? getDefaultLinkColor(color) : color
})}

    ${getDeclaration({
  blockName: _selectors.BLOCK_NAME_INTERACTED,
  declarations: [{
    property: 'color',
    value: getDefaultLinkHoverColor ? getDefaultLinkHoverColor(colorHover) : colorHover
  }],
  applyToElementDirectly: true
})}

    ${getDeclaration({
  blockName: _selectors.BLOCK_NAME_DISABLED,
  declarations: [{
    property: 'cursor',
    value: 'not-allowed'
  }, {
    property: 'color',
    value: colorDisabled || color
  }],
  applyToElementDirectly: true
})}  

    ${svgStyle({
  width: svgWidth,
  height: svgHeight,
  verticalAlign: 'middle',
  noSvgStyles,
  getDefaultColor: getDefaultLinkColor,
  getDefaultHoverColor: getDefaultLinkHoverColor
})}
  }
`;
const buttonVariantToggle = ({
  color,
  colorHover,
  background,
  backgroundHover,
  svgWidth,
  svgHeight,
  noSvgStyles,
  getDefaultBackground,
  getDefaultColor,
  getDefaultFocusBackground,
  getDefaultFocusColor,
  getDefaultHoverBackground,
  getDefaultHoverColor
}) => `
  ${buttonVariantSolid({
  color,
  colorHover,
  background,
  backgroundHover,
  svgWidth,
  svgHeight,
  noSvgStyles,
  getDefaultBackground,
  getDefaultColor,
  getDefaultFocusBackground,
  getDefaultFocusColor,
  getDefaultHoverBackground,
  getDefaultHoverColor
})}

  ${!noSvgStyles ? `
      & > svg {
        polygon, path {
          fill: ${getDeclaration({
  variableName: 'color',
  value: getDefaultColor ? getDefaultColor(color) : color
})};
        }
      }
    ` : ''}

   :focus {
      background: ${getDeclaration({
  variableName: 'focus-background',
  value: getDefaultFocusBackground ? getDefaultFocusBackground(background) : background
})};
      color: ${getDeclaration({
  variableName: 'focus-color',
  value: getDefaultFocusColor ? getDefaultFocusColor(color) : color
})};

      ${!noSvgStyles ? `
        & > svg {
          polygon, path {
            fill: ${getDeclaration({
  variableName: 'focus-color',
  value: getDefaultFocusColor ? getDefaultFocusColor(color) : color
})};
          }
        }
      ` : ''}
  }
`;
const buttonStyles = _ref2 => {
  let {
      size,
      type,
      toolbar,
      colorDisabled,
      color,
      colorHover,
      background,
      backgroundHover,
      svgWidth,
      svgHeight,
      noSvgStyles,
      positioning,
      withShadow,
      useAppTheme
    } = _ref2,
    others = (0, _objectWithoutPropertiesLoose2.default)(_ref2, _excluded2);
  return `
  background-image: none;
  line-height: 1.6;
  margin-bottom: 0;
  text-align: center;
  touch-action: manipulation;
  user-select: none;
  vertical-align: middle;
  white-space: nowrap;

  ${getDeclaration({
    property: 'font-size',
    value: `${_theme.default.fontSizes[40]}px`
  })}
  ${getDeclaration({
    property: 'border-color',
    value: `transparent`,
    isImportant: true
  })}
  ${getDeclaration({
    property: 'border',
    value: '1px solid transparent'
  })}
  ${getDeclaration({
    property: 'border-radius',
    value: '0'
  })}
  ${getDeclaration({
    property: 'cursor',
    value: 'pointer'
  })}
  
  ${!useAppTheme ? `
    display: inline-flex;
    align-items: center;
    justify-content: center;

    ${getDeclaration({
    property: 'padding',
    value: '6px 12px'
  })}
    
  ` : ''}

  ${positioning === 'outer' ? `
    justify-content: space-between;
  ` : ''}

  ${withShadow ? `
      ${getDeclaration({
    property: 'box-shadow',
    value: 'rgba(0, 0, 0, 0.1) 0px 3px 15px 0px'
  })}
  ` : ''}

  ${size === SIZE_SMALL ? `
      font-size: ${_theme.default.fontSizes[30]}px;
      ${getDeclaration({
    property: 'height',
    value: '30px'
  })}
      ${getDeclaration({
    property: 'line-height',
    value: '30px'
  })}
      ${getDeclaration({
    property: 'padding',
    value: '0 10px'
  })}
    ` : ''}

    ${size === SIZE_LARGE ? ` 
      ${getDeclaration({
    property: 'height',
    value: '48px'
  })}
      ${getDeclaration({
    property: 'padding',
    value: '0 24px'
  })}
      ${getDeclaration({
    property: 'font-size',
    value: '16px'
  })}
      line-height: 46px;
      ` : ''}

  ${size === SIZE_HUGE ? `
      ${getDeclaration({
    property: 'height',
    value: '64px'
  })}
      ${getDeclaration({
    property: 'padding',
    value: '0 30px'
  })}
      ${getDeclaration({
    property: 'font-size',
    value: '16px'
  })}
  ` : ''}

   ${type === 'default' ? useAppTheme ? toolbar ? buttonVariantSolid(Object.assign({
    color: _appTheme.default.colors.blacks[50],
    colorHover: _appTheme.default.colors.black,
    background: _appTheme.default.colors.blacks[20],
    backgroundHover: 'white',
    useAppTheme
  }, others)) : '' : buttonVariantSolid(Object.assign({
    color: 'white',
    background: _theme.default.colors.blacks[50],
    backgroundHover: _theme.default.colors.blacks[40],
    size,
    useAppTheme
  }, others)) : ''}

  ${toolbar && toolbarCss};

  ${type === 'toolbar' && `${buttonVariantSolid(Object.assign({
    color: _appTheme.default.colors.blacks[50],
    background: _appTheme.default.colors.circleButton.background,
    backgroundHover: _appTheme.default.colors.circleButton.backgroundHover,
    svgWidth,
    svgHeight,
    noSvgStyles,
    useAppTheme
  }, others))}
    ${getDeclaration({
    property: 'font-weight',
    value: `${_appTheme.default.fontWeights.semiBold}`,
    isImportant: true
  })}
     ${getDeclaration({
    property: 'border-radius',
    value: `20px`,
    isImportant: true
  })}
    `};

  ${type === 'cta' ? buttonVariantSolid(Object.assign({
    color: _theme.default.colors.black,
    background: (useAppTheme ? _appTheme.default : _theme.default).colors.green,
    backgroundHover: useAppTheme ? _theme.default.colors.greens[40] : _theme.default.colors.hoverGreen,
    size,
    svgWidth,
    svgHeight,
    noSvgStyles,
    useAppTheme
  }, others)) : ''}

  ${
  // only in app; not in marketing site
  type === 'cta-alt' ? buttonVariantSolid(Object.assign({
    color: 'white',
    background: _appTheme.default.colors.pink,
    backgroundHover: _appTheme.default.colors.pinks[40],
    size,
    svgWidth,
    svgHeight,
    noSvgStyles,
    useAppTheme
  }, others)) : ''}

  ${
  // only in app; not in marketing site
  type === 'cta-light' ? `
    ${buttonVariantSolid(Object.assign({
    color: _appTheme.default.colors.blacks[50],
    background: _appTheme.default.colors.green,
    backgroundHover: _appTheme.default.colors.greens[40],
    svgWidth,
    svgHeight,
    noSvgStyles,
    useAppTheme
  }, others))}
    ${getDeclaration({
    property: 'opacity',
    value: '0.5'
  })}
    ` : ''};

  ${type === 'primary' ? buttonVariantSolid(Object.assign({
    color: 'white',
    background: (useAppTheme ? _appTheme.default : _theme.default).colors.blue,
    backgroundHover: (useAppTheme ? _appTheme.default : _theme.default).colors.blues[40],
    size,
    svgWidth,
    svgHeight,
    noSvgStyles,
    useAppTheme
  }, others)) : ''}

  ${type === 'danger' ? buttonVariantSolid(Object.assign({
    color: useAppTheme ? 'white' : _theme.default.colors.reds[80],
    background: _theme.default.colors.red,
    backgroundHover: (useAppTheme ? _appTheme.default : _theme.default).colors.reds[40],
    size,
    svgWidth,
    svgHeight,
    noSvgStyles,
    useAppTheme
  }, others)) : ''}

  ${type === 'black' ? buttonVariantSolid(Object.assign({
    color: 'white',
    background: (useAppTheme ? _appTheme.default : _theme.default).colors.black,
    backgroundHover: useAppTheme ? _appTheme.default.colors.blacks[40] : _theme.default.colors.blacks[70],
    size,
    chevronColor: _theme.default.colors.green,
    chevronColorHover: _theme.default.colors.greens[20],
    chevronClassName: CHEVRON_CLASS_NAME,
    useAppTheme
  }, others)) : ''}

  ${type === 'dark' ? buttonVariantSolid(Object.assign({
    color: 'white',
    background: _theme.default.colors.blacks[60],
    backgroundHover: _theme.default.colors.blacks[40],
    size,
    chevronColor: _theme.default.colors.green,
    chevronColorHover: _theme.default.colors.greens[20],
    chevronClassName: CHEVRON_CLASS_NAME,
    useAppTheme
  }, others)) : ''}

  ${type === 'outline-default' ? buttonVariantOutline(Object.assign({
    color: (useAppTheme ? _appTheme.default : _theme.default).colors.black,
    colorHover: useAppTheme ? _appTheme.default.colors.black : _theme.default.colors.blacks[60],
    border: useAppTheme ? _appTheme.default.colors.blacks[50] : _theme.default.colors.black,
    borderHover: useAppTheme ? _appTheme.default.colors.black : _theme.default.colors.blacks[60],
    size,
    chevronColor: _theme.default.colors.green,
    chevronColorHover: _theme.default.colors.greens[40],
    chevronClassName: CHEVRON_CLASS_NAME,
    useAppTheme
  }, others)) : ''}

  ${type === 'outline-faded' ? buttonVariantOutline(Object.assign({
    color: (useAppTheme ? _appTheme.default : _theme.default).colors.black,
    colorHover: (useAppTheme ? _appTheme.default : _theme.default).colors.black,
    border: (useAppTheme ? _appTheme.default : _theme.default).colors.blues[10],
    borderHover: (useAppTheme ? _appTheme.default : _theme.default).colors.black,
    size,
    useAppTheme
  }, others)) : ''}

  ${
  // only in app; not in marketing site
  type === 'outline-light' ? `
      ${buttonVariantOutline(Object.assign({
    color: _appTheme.default.colors.radioButton.color,
    colorHover: _appTheme.default.colors.radioButton.colorHover,
    background: _appTheme.default.colors.radioButton.background,
    backgroundHover: _appTheme.default.colors.radioButton.backgroundHover,
    border: _appTheme.default.colors.radioButton.border,
    borderHover: _appTheme.default.colors.radioButton.borderHover,
    svgWidth,
    svgHeight,
    noSvgStyles,
    useAppTheme
  }, others))}
     ${getDeclaration({
    property: 'font-weight',
    value: `${_appTheme.default.fontWeights.normal}`,
    isImportant: true
  })}
    ` : ''}

  ${
  // only in app; not in marketing site
  type === 'outline-green' ? `
    ${buttonVariantOutline(Object.assign({
    color: _appTheme.default.colors.radioButton.color,
    colorHover: _appTheme.default.colors.radioButton.colorHover,
    background: _appTheme.default.colors.radioButton.background,
    backgroundHover: _appTheme.default.colors.radioButton.backgroundHover,
    border: _appTheme.default.colors.greens[40],
    borderHover: _appTheme.default.colors.greens[40],
    svgWidth,
    svgHeight,
    noSvgStyles,
    useAppTheme
  }, others))}
    ${getDeclaration({
    property: 'font-weight',
    value: `${_appTheme.default.fontWeights.normal}`,
    isImportant: true
  })}
    ` : ''}

  ${
  // only in app; not in marketing site
  type === 'outline-red' ? `
    ${buttonVariantOutline(Object.assign({
    color: _appTheme.default.colors.radioButton.color,
    colorHover: _appTheme.default.colors.radioButton.colorHover,
    background: _appTheme.default.colors.radioButton.background,
    backgroundHover: _appTheme.default.colors.radioButton.backgroundHover,
    border: _appTheme.default.colors.reds[40],
    borderHover: _appTheme.default.colors.reds[40],
    svgWidth,
    svgHeight,
    noSvgStyles,
    useAppTheme
  }, others))}
     ${getDeclaration({
    property: 'font-weight',
    value: `${_appTheme.default.fontWeights.normal}`,
    isImportant: true
  })}
    ` : ''}

   ${
  // only in app; not in marketing site
  type === 'yellow' ? buttonVariantSolid(Object.assign({
    color: _appTheme.default.colors.blacks[50],
    background: _appTheme.default.colors.yellow,
    backgroundHover: _appTheme.default.colors.yellows[40],
    svgWidth,
    svgHeight,
    noSvgStyles,
    useAppTheme
  }, others)) : ''}

  ${
  // only in app; not in marketing site
  type === 'solid-black' ? buttonVariantSolid(Object.assign({
    color: 'white',
    background: _appTheme.default.colors.black,
    backgroundHover: _appTheme.default.colors.blacks[40],
    svgWidth,
    svgHeight,
    noSvgStyles,
    useAppTheme
  }, others)) : ''}

  ${
  // only in app; not in marketing site
  type === 'inactive' ? buttonVariantSolid(Object.assign({
    color: _appTheme.default.colors.blacks[50],
    background: _appTheme.default.colors.blacks[20],
    colorHover: 'white',
    backgroundHover: _appTheme.default.colors.blacks[40],
    svgWidth,
    svgHeight,
    noSvgStyles,
    useAppTheme
  }, others)) : ''}

  ${
  // only in app; not in marketing site
  type === 'white' ? buttonVariantOutline(Object.assign({
    color: _appTheme.default.colors.black,
    colorHover: _appTheme.default.colors.blacks[40],
    svgWidth,
    svgHeight,
    noSvgStyles,
    useAppTheme
  }, others)) : ''}

   ${
  // only in app; not in marketing site
  type === 'toggle-inactive' ? buttonVariantToggle(Object.assign({
    color: _appTheme.default.colors.black,
    colorHover: _appTheme.default.colors.black,
    background: _appTheme.default.colors.blacks[10],
    backgroundHover: _appTheme.default.colors.blacks[20],
    svgWidth,
    svgHeight,
    noSvgStyles,
    useAppTheme
  }, others)) : ''}

  ${
  // only in app; not in marketing site
  type === 'toggle-active' ? buttonVariantToggle(Object.assign({
    color: _appTheme.default.colors.black,
    colorHover: _appTheme.default.colors.black,
    background: _appTheme.default.colors.blacks[20],
    backgroundHover: _appTheme.default.colors.blacks[20],
    svgWidth,
    svgHeight,
    noSvgStyles,
    useAppTheme
  }, others)) : ''}

  ${color && background && backgroundHover ? buttonVariantSolid(Object.assign({
    color,
    background,
    backgroundHover,
    size,
    useAppTheme
  }, others)) : ''};

  ${type === 'link' || type === 'faded' ? `
      && {
        font-weight: inherit;
        line-height: inherit;
        text-align: inherit;
        height: inherit;
        box-shadow: noned;
        vertical-align: bottom;
        
        ${getDeclaration({
    property: 'background',
    value: 'none'
  })}
        ${getDeclaration({
    property: 'border',
    value: 'none'
  })}
        ${getDeclaration({
    property: 'padding',
    value: '0'
  })}
        ${getDeclaration({
    property: 'transition',
    value: 'color 0.1s ease'
  })}
      }

      > * {
        display: inline-block;
        vertical-align: middle;
      }

      ${getDeclaration({
    blockName: _selectors.BLOCK_NAME_INTERACTED,
    declarations: [{
      property: 'background',
      value: 'none'
    }],
    applyToElementDirectly: true
  })}  

      ${getDeclaration({
    blockName: _selectors.BLOCK_NAME_DISABLED,
    declarations: [{
      property: 'background',
      value: 'transparent',
      isImportant: true
    }, {
      property: 'line-height',
      value: 'inherit',
      isImportant: true
    }, {
      property: 'opacity',
      value: '0.5'
    }],
    applyToElementDirectly: true
  })}  
    ` : `
      `}

  ${(type === 'link' || type === 'faded') && !noSvgStyles ? `
        svg {
          display: inline-block;
          vertical-align: middle;
          width: 14px;
          height: 14px;
          margin-right: 8px;

          path,
          polygon,
          rect {
            transition: fill 0.1s ease;
          }

          &:last-child {
            margin-right: 0;
          }
        }
        ` : ''} 

  ${(type === 'link' || type === 'faded') && !noSvgStyles ? svgColorStyles(Object.assign({
    color: (useAppTheme ? _appTheme.default : _theme.default).textColors.subtle,
    colorHover: (useAppTheme ? _appTheme.default : _theme.default).colors.textColor,
    noSvgStyles
  }, others, {
    type: 'DIRECT'
  })) : ''}

  ${type === 'link' ? buttonVariantLink(Object.assign({
    color: color || (useAppTheme ? _appTheme.default : _theme.default).textColors.link,
    colorHover: colorHover || (useAppTheme ? _appTheme.default : _theme.default).textColors.linkHover,
    colorDisabled: colorDisabled || (useAppTheme ? _appTheme.default : _theme.default).textColors.subtle,
    svgWidth,
    svgHeight,
    noSvgStyles,
    useAppTheme
  }, others)) : ''};

  

  ${type === 'link' ? `
      font-size: 14px;
    ` : ''}

  ${type === 'link' && size === SIZE_SMALL ? `
      font-size: 12px;
    ` : ''}

  ${type === 'link' && size === SIZE_LARGE && !noSvgStyles ? `
        svg {
          width: 16px;
          height: 16px;
        }
      ` : ''}


  ${type === 'faded' ? `
      display: flex;
      flex-direction: row;
      align-items: center;
      color: ${(useAppTheme ? _appTheme.default : _theme.default).textColors.subtle};
      font-weight: ${(useAppTheme ? _appTheme.default : _theme.default).fontWeights.bold};

      ${getDeclaration({
    blockName: _selectors.BLOCK_NAME_DISABLED,
    declarations: [{
      property: 'color',
      value: colorDisabled,
      isImportant: true
    }],
    applyToElementDirectly: true
  })}  

      &:active,
      &:focus,
      &:hover {
        color: ${(useAppTheme ? _appTheme.default : _theme.default).colors.textColor};
      }
  ` : ''}

   ${type === 'faded' && size === SIZE_SMALL && !noSvgStyles ? `
        svg {
          width: 12px;
          height: 12px;
        }
      ` : ''}

  ${type === 'faded' && size === SIZE_LARGE && !noSvgStyles ? `
        svg {
          width: 20px;
          height: 20px;
        }
      ` : ''}
`;
};
const DO_NOT_FORWARD_PROPS = ['toolbar', 'colorDisabled', 'colorHover', 'buttonText', 'buttonURL', 'backgroundHover', 'svgWidth', 'svgHeight', 'noSvgStyles', 'size', 'type', 'withShadow', 'positioning', 'color', 'background', 'backgroundHover', 'colordisabled', 'useAppTheme', 'getDefaultBackground', 'getDefaultColor', 'getDefaultFocusBackground', 'getDefaultFocusColor', 'getDefaultHoverBackground', 'getDefaultHoverColor', 'getDefaultLinkColor', 'getDefaultLinkHoverColor'];
const ButtonStyled = exports.ButtonStyled = _styledComponents.default.button.withConfig({
  shouldForwardProp: prop => !DO_NOT_FORWARD_PROPS.includes(prop)
})`
  ${props => buttonStyles(props)}
`;
const AStyled = (0, _styledComponents.default)('a').withConfig({
  shouldForwardProp: prop => DO_NOT_FORWARD_PROPS.indexOf(prop) === -1
})`
  ${props => buttonStyles(props)}
`;
const LoadingContainer = _styledComponents.default.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;

  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;

  background: rgba(255, 255, 255, 0.8);
  z-index: 10;
`;
function sizeClass(size) {
  if (size === SIZE_SMALL) return 'ant-btn-sm';
  if (size === SIZE_MEDIUM) return 'ant-btn-lg';
  if (size === SIZE_LARGE) return 'ant-btn-lg';
  return '';
}
const BUTTON_CONTENT_MARGIN = 8;
const Button = _ref3 => {
  let {
      to,
      target,
      href,
      // href is deprecated, use to instead
      type,
      size,
      children,
      isSubmit,
      className,
      isLoading,
      withShadow,
      chevron,
      linkComponent,
      alwaysUseLinkComponent,
      buttonComponent,
      // primarily used by the app to pass in AntButton
      background,
      backgroundHover,
      color,
      colorHover,
      noSvgStyles,
      useAppTheme,
      getDefaultBackground,
      getDefaultColor,
      getDefaultFocusBackground,
      getDefaultFocusColor,
      getDefaultHoverBackground,
      getDefaultHoverColor,
      getDefaultLinkColor,
      getDefaultLinkHoverColor
    } = _ref3,
    others = (0, _objectWithoutPropertiesLoose2.default)(_ref3, _excluded3);
  // add white label class to the button
  className = `${className || ''} ${WHITELABEL_SELECTOR_CLASS}`;
  let linkProps = {
    className: useAppTheme ? `ant-btn ant-btn-${type} ${sizeClass(size)} ${className || ''}` : className
  };
  let buttonProps = {};
  let Component = ButtonStyled;
  if (to || href) {
    Component = AStyled;
    const isInternalLink = to && !(0, _helpers.isAbsoluteUrl)(to);

    // TODO: simplify this logic once href is removed
    linkProps = to ? isInternalLink ? Object.assign({}, linkProps, {
      to,
      target
    }) : Object.assign({}, linkProps, {
      href: to,
      target: target || '_blank'
    }) : Object.assign({}, linkProps, {
      href,
      target: target || '_blank'
    });
    if (linkComponent && (alwaysUseLinkComponent || to && isInternalLink)) {
      linkProps.as = linkComponent;
    }
  } else {
    buttonProps = {
      htmlType: isSubmit ? 'submit' : 'button',
      className
    };
    if (buttonComponent) {
      buttonProps.as = buttonComponent;
    }
  }
  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
    type: type
    // buttonType is used to enable css whitelabel selectors for diff button types
    // TODO: it should be lowercase to make the DOM happy, but if customers are whitelabeling
    // they with this they would have to update their CSS....
    ,
    buttontype: type,
    size: size,
    withShadow: withShadow,
    positioning: chevron?.position,
    color: color,
    colorHover: colorHover,
    background: background,
    backgroundHover: backgroundHover,
    noSvgStyles: noSvgStyles,
    useAppTheme: useAppTheme,
    getDefaultBackground: getDefaultBackground,
    getDefaultColor: getDefaultColor,
    getDefaultFocusBackground: getDefaultFocusBackground,
    getDefaultFocusColor: getDefaultFocusColor,
    getDefaultHoverBackground: getDefaultHoverBackground,
    getDefaultHoverColor: getDefaultHoverColor,
    getDefaultLinkColor: getDefaultLinkColor,
    getDefaultLinkHoverColor: getDefaultLinkHoverColor
  }, buttonProps, linkProps, others), chevron && chevron?.direction !== 'right' && /*#__PURE__*/_react.default.createElement(_IconChevronLeft.default, {
    style: {
      marginRight: BUTTON_CONTENT_MARGIN
    },
    className: CHEVRON_CLASS_NAME
  }), children, isLoading ? /*#__PURE__*/_react.default.createElement(LoadingContainer, null, /*#__PURE__*/_react.default.createElement(_LoadingSpinner.default, null)) : null, chevron && chevron?.direction === 'right' && /*#__PURE__*/_react.default.createElement(_IconChevronRight.default, {
    style: {
      marginLeft: BUTTON_CONTENT_MARGIN
    },
    className: CHEVRON_CLASS_NAME
  }));
};
Button.defaultProps = {
  to: null,
  href: null,
  isSubmit: false,
  isLoading: false,
  type: 'default',
  size: 'default',
  alwaysUseLinkComponent: false
};
Button.propTypes = {
  isSubmit: _propTypes.default.bool,
  isLoading: _propTypes.default.bool,
  withShadow: _propTypes.default.bool,
  to: _propTypes.default.string,
  href: _propTypes.default.string,
  buttonComponent: _propTypes.default.elementType,
  linkComponent: _propTypes.default.elementType,
  alwaysUseLinkComponent: _propTypes.default.bool,
  type: _propTypes.default.oneOf(PROP_TYPES),
  size: _propTypes.default.oneOf(PROP_SIZES),
  children: _propTypes.default.node.isRequired,
  className: _propTypes.default.string,
  chevron: _propTypes.default.shape({
    direction: _propTypes.default.oneOf(CHEVRON_DIRECTIONS),
    position: _propTypes.default.oneOf(CHEVRON_POSITIONS)
  }),
  toolbar: _propTypes.default.bool,
  // FIXME: to color toolbar buttons. it's crappy

  // Custom colors: all of these props must be specified to trigger custom styles
  // When using `type=link` only `color`, `colorHover`, and `colorDisabled` are required.
  color: _propTypes.default.string,
  background: _propTypes.default.string,
  backgroundHover: _propTypes.default.string,
  // Custom color for links
  colorHover: _propTypes.default.string,
  // Custom width/height of svg
  svgWidth: _propTypes.default.string,
  svgHeight: _propTypes.default.string,
  useAppTheme: _propTypes.default.bool,
  noSvgStyles: _propTypes.default.bool,
  // default whitelabel props - these values are managed by the app
  getDefaultBackground: _propTypes.default.func,
  getDefaultColor: _propTypes.default.func,
  getDefaultFocusBackground: _propTypes.default.func,
  getDefaultFocusColor: _propTypes.default.func,
  getDefaultHoverBackground: _propTypes.default.func,
  getDefaultHoverColor: _propTypes.default.func,
  getDefaultLinkColor: _propTypes.default.func,
  getDefaultLinkHoverColor: _propTypes.default.func
};
var _default = exports.default = Button;